import React from "react";
import TestimonialCarousel from "./TestimonialCarousel";

const MarketingStack = () => {
  return (
    <section
      className="marketing-container marketing-stack-container"
      id="marketing-stack"
    >
      <div className="marketing-stack-row">
        <div className="stack-headline-col">
          <span className="stack-headline-txt headline-underline headline-underline-stack">
            Marketing
          </span>
          <span className="stack-headline-txt headline-underline stack-headline-sub headline-underline-stack">
            Stack
          </span>
        </div>

        <div className="stack-icons-col">
          <div className="flex-row-start stack-icons-row">
            <img src="crm.png" alt="CRM Icon" className="stack-icons" />
            <span className="stack-icon-cat-title">CRM</span>
            <span className="stack-icon-desc">Hubspot, Salesforce</span>
          </div>
          <div className="flex-row-start stack-icons-row">
            <img src="ai.png" alt="AI Icon" className="stack-icons" />
            <span className="stack-icon-cat-title">AI</span>
            <span className="stack-icon-desc">ChatGPT, CoPilot</span>
          </div>
          <div className="flex-row-start stack-icons-row">
            <img src="email.png" alt="Email Icon" className="stack-icons" />
            <span className="stack-icon-cat-title">Email</span>
            <span className="stack-icon-desc">Mailchimp, Klaviyo</span>
          </div>
          <div className="flex-row-start stack-icons-row">
            <img
              src="paidads.png"
              alt="Paid Ads Icon"
              className="stack-icons paidads-icon"
            />
            <span className="stack-icon-cat-title">Ads</span>
            <span className="stack-icon-desc">Meta(FB/IG), Google</span>
          </div>
          <div className="flex-row-start stack-icons-row">
            <img
              src="automation.png"
              alt="Automation Icon"
              className="stack-icons automation-icon"
            />
            <span className="stack-icon-cat-title">Automation</span>
            <span className="stack-icon-desc">Custom Workflows</span>
          </div>
          <div className="flex-col"></div>
          <div className="flex- col stack-icons-desc-col"></div>
        </div>
      </div>

      <TestimonialCarousel />
    </section>
  );
};

export default MarketingStack;
